import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AppService } from '../../services/app.service';
import { TermsOfService, TermsOfServiceService } from 'riterz-core';

@Component({
  selector: 'rt-terms-of-service',
  imports: [
    CommonModule,
    ButtonModule
  ],
  standalone: true,
  templateUrl: 'terms-of-service.component.html',
  styleUrl: 'terms-of-service.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class TermsOfServiceComponent implements OnInit {
  private appService = inject(AppService);
  private dialogConfig = inject(DynamicDialogConfig);
  private dialogRef = inject(DynamicDialogRef);
  private termsOfServiceService = inject(TermsOfServiceService);

  readonly termsOfService = signal<TermsOfService|null>(null);

  readonly showContent = signal<boolean>(false);

  ngOnInit(): void {
    this.getTermsOfService();
  }

  getTermsOfService(): void {
    this.termsOfServiceService
      .public
      .getTermsOfServices()
      .subscribe({
        next: (response) => {
          this.termsOfService.set(response);
        }
      });
  }

  toggleContent(): void {
    this.showContent.set(!this.showContent());
  }

  accept(): void {
    this.termsOfServiceService
      .acceptTermsOfService()
      .subscribe({ 
        next: () => {
          this.dialogRef.close();
        }
      });
  }
}